import TextField from "@/common/elements/InputElements/TextField";
import Modal from "@/common/elements/Modal";
import _ from "lodash";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { FormContainer } from "./styles";
import { ModalBody } from "@/common/elements/Modal/styles";
import { labels } from "@/util/label";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
  StyledUploadLinkPath,
} from "@/common/styles";
import { Button, Flex, Form } from "antd";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import { StyledDate } from "../InmateDetails/styles";
import CommonDatePicker from "@/common/elements/DatePicker";
import dayjs from "dayjs";
import FileUpload from "@/common/elements/InputElements/Upload";
import FileUploader from "../FileUploader";
import Select from "@/common/elements/InputElements/Select";
import {
  getOptionsFromRefList,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import { PHOTOS_BASE_URL } from "@/util/api";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST,
  MODULES_LIST_WITH_ID,
  SCHEMA_NAME,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";
import { useSelector } from "react-redux";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";

export const MODE = { NEW: "new", EDIT: "edit" };

const DocsModal = forwardRef(
  (
    {
      document,
      show,
      handleCancel,
      handleSubmit,
      isLinkedDocs,
      isEdit,
      setIsEdit,
      bookingsFieldsEnabled,
      from,
      startingPoint,
    },
    ref,
  ) => {
    const [form] = Form.useForm();
    const [formData, setFormData] = useState(null);
    const [isImgUploading, setIsImgUploading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    useEffect(() => {
      if (isEdit) {
        let isShow = hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.MODIFY,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Arrest_Report,
        );
        if (isShow) {
          setIsDisabled(false);
        } else {
          setIsDisabled(true);
        }
      } else {
        setIsDisabled(false);
      }
    }, [isEdit]);
    // Expose form methods to parent
    useImperativeHandle(ref, () => ({
      submitForm: () => form.submit(),
      resetForm: () => form.resetFields(),
      getFormValues: () => form.getFieldsValue(),
      getFieldsError: () => form.getFieldsError(),
      isFieldsValidating: () => form.isFieldsValidating(),
      validateFields: () => form.validateFields(),
      form: form,
    }));

    useEffect(() => {
      console.log("document", document);
      setFormData(() => ({
        ...document,
        documentDate: isNonEmptyVariable(document?.documentDate)
          ? dayjs(document?.documentDate)
          : null,
      }));
    }, [document]);

    useEffect(() => {
      if (formData) {
        const updateFormData = {
          ...formData,
          description: formData?.originalData?.photos?.[0]?.description,
          fullSizePath: !isLinkedDocs
            ? formData?.originalData?.photos?.[0]?.fullSizePath
            : "",
        };

        form.setFieldsValue(updateFormData);
      }
    }, [formData]);

    const documentType = Form.useWatch("documentType", form);
    // form.getFieldValue() read directly in JSX never re-fires a render —
    // the fullSizePath field is only populated later via form.setFieldsValue
    // inside the [formData] effect below (so the preview can show an
    // already-uploaded photo when reopening Details), which updates antd's
    // internal form store but not React state. Without watching it here,
    // FileUploader's imageUrlFromParent stayed frozen at whatever blank
    // value was computed on the very first render, so a real, already-saved
    // fullSizePath (confirmed present in the GET response) never reached it.
    const fullSizePathValue = Form.useWatch("fullSizePath", form);
    const fullSearch = useSelector((state) => state.fullSearch);

    const onSuccessDocsUplod = (v) => {
      form.setFieldValue("documentPath", v?.documentPath);
    };

    const getFinalPath = (path) => {
      if (path?.includes("\\")) {
        const splitPath = path.split("/");
        if (splitPath.length === 4) {
          splitPath.shift();
          splitPath.shift();
        }
        return splitPath.join("\\");
      }
      return path;
    };

    const onUpload = (e) => {
      const formData = new FormData();
      formData.append("file", e);
      formData.append("imageType", form.getFieldValue("documentType"));
      formData.append("description", form.getFieldValue("description"));

      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      setIsImgUploading(true);

      api
        .post(API_ENDPOINTS?.imageUpload, formData, config)
        .then((response) => {
          const body = response?.data?.body;
          console.log(
            "body",
            PHOTOS_BASE_URL + getFinalPath(body?.fullSizePath),
          );

          form.setFieldValue("fullSizePath", body?.fullSizePath);
          form.setFieldValue("thumbnailPath", body?.thumbnailPath);
        })
        .finally(() => {
          setIsImgUploading(false);
        });
    };
    function handleFormCancel() {
      form.resetFields();
      handleCancel();
    }
    return (
      <>
        <Modal
          show={show}
          header={`${document ? "VIEW" : "ADD"} Document`}
          size="xl"
          onHide={handleFormCancel}
          designPattern="ant"
          width="70%"
          loading={isImgUploading}
          handleCancel={handleFormCancel}
          handleSubmit={handleSubmit}
          hideSubmitButton={
            from == MODULES_LIST.FACILITY_LOG ? false : isDisabled
          }
          footerCloseAction={() => setIsDisabled(false)}
          submitButtonDisabled={!bookingsFieldsEnabled}
          footerActions={[
            <Button key="SUBMIT" onClick={handleFormCancel}>
              Close
            </Button>,
            <Button
              key="SUBMIT"
              onClick={handleSubmit}
              disabled={!bookingsFieldsEnabled}
            >
              Save
            </Button>,
          ]}
        >
          <ModalBody>
            <FormContainer>
              <FieldSecurityProvider
                entity={SCHEMA_NAME.DOCUMENTS}
                startingPoint={startingPoint}
                bookingsFieldsEnabled={bookingsFieldsEnabled}
              >
                <Form form={form} initialValues={formData}>
                  <StyledGridRow gutter={16}>
                    <StyledGridCol span={24} lg={24}>
                      <StyledSectionHeading marginTop="0px">
                        <span>Document Information</span>
                      </StyledSectionHeading>
                    </StyledGridCol>
                    <StyledGridCol span={8}>
                      <SecureFormItem
                        fieldName="documentName"
                        formItemProps={{
                          name: "documentName",
                          label: labels.documentName,
                        }}
                      >
                        <Select
                          placeholder="Document Name"
                          options={[
                            {
                              label: "",
                              value: "",
                            },
                            {
                              label: "Stub",
                              value: "Stub",
                            },
                          ]}
                          disabled={!bookingsFieldsEnabled}
                        />
                      </SecureFormItem>
                    </StyledGridCol>

                    <StyledGridCol span={8}>
                      <SecureFormItem
                        fieldName="documentDate"
                        formItemProps={{
                          name: "documentDate",
                          label: labels.documentDate,
                        }}
                      >
                        <CommonDatePicker
                          showTime={false}
                          placeholder="MM/DD/YYYY"
                          format="MM/DD/YYYY"
                          disabled={!bookingsFieldsEnabled}
                        />
                      </SecureFormItem>
                    </StyledGridCol>

                    <StyledGridCol span={8}>
                      <SecureFormItem
                        fieldName="author"
                        formItemProps={{ name: "author", label: labels.author }}
                      >
                        <TextField placeholder="Author" />
                      </SecureFormItem>
                    </StyledGridCol>
                  </StyledGridRow>

                  <StyledGridRow>
                    <StyledGridCol span={24}>
                      <SecureFormItem
                        fieldName="comments"
                        formItemProps={{
                          name: "comments",
                          label: labels.comments,
                        }}
                      >
                        <TextField
                          inputType="textarea"
                          placeholder="Comments"
                          rows={5}
                        />
                      </SecureFormItem>
                    </StyledGridCol>
                  </StyledGridRow>

                  <StyledGridRow gutter={15}>
                    <StyledGridCol lg={24} span={24}>
                      <StyledSectionHeading>
                        <span>
                          {isLinkedDocs
                            ? "Linked Documents"
                            : "Photo Information"}
                        </span>
                      </StyledSectionHeading>
                    </StyledGridCol>
                    <StyledGridCol span={8}>
                      <SecureFormItem
                        fieldName="documentType"
                        formItemProps={{
                          name: "documentType",
                          label: "Document Type",
                        }}
                      >
                        <Select
                          options={getOptionsFromRefList("Image_Type")}
                          placeholder="Document Type"
                          disabled={!bookingsFieldsEnabled}
                        />
                      </SecureFormItem>
                    </StyledGridCol>
                    {isLinkedDocs ? (
                      <>
                        <StyledGridCol span={15}>
                          <SecureFormItem
                            fieldName="documentPath"
                            formItemProps={{
                              name: "documentPath",
                              label: labels.documentPath,
                              // ASP (DocumentInterfaceHelper.asp HandleValidateData)
                              // blocks saving a Linked Document with no
                              // Document_Path - it never lets an empty path pass
                              // its file-extension check. Imats only checked the
                              // extension when a path was already typed in
                              // (Docs.jsx handleSubmit), so a blank path skipped
                              // validation entirely and saved. Mirrors the
                              // `description` field's required pattern below.
                              required: !fullSearch,
                              rules: !fullSearch
                                ? [
                                    {
                                      required: true,
                                      message: `${labels.documentPath} is required`,
                                    },
                                  ]
                                : [],
                            }}
                          >
                            <TextField placeholder="Document Path" required />
                          </SecureFormItem>
                        </StyledGridCol>

                        <StyledGridCol span={8}>
                          <FormItem name="upload" label="Upload">
                            <FileUpload
                              payload={{ documentType: documentType }}
                              onSuccess={onSuccessDocsUplod}
                              name="docs"
                            ></FileUpload>
                          </FormItem>
                        </StyledGridCol>
                      </>
                    ) : (
                      <>
                        <StyledGridCol span={8}>
                          <SecureFormItem
                            fieldName="description"
                            formItemProps={{
                              name: "description",
                              label: labels.description,
                              required: !fullSearch,
                              rules: !fullSearch
                                ? [
                                    {
                                      required: true,
                                      message: `${labels.description} is required`,
                                    },
                                  ]
                                : [],
                            }}
                            entityOverride={SCHEMA_NAME.PHOTOS}
                          >
                            <TextField placeholder="Description" required />
                          </SecureFormItem>
                        </StyledGridCol>

                        <StyledGridCol span={8}>
                          <FormItem name="fullSizePath" label={labels.upload}>
                            <FileUploader
                              browseFileType="image"
                              acceptImageFormats="image/png,image/jpeg,image/jpg"
                              allowMultiple={false}
                              onUpload={onUpload}
                              imageUrlFromParent={
                                fullSizePathValue
                                  ? PHOTOS_BASE_URL +
                                    getFinalPath(fullSizePathValue)
                                  : ""
                              }
                            />
                          </FormItem>
                        </StyledGridCol>
                      </>
                    )}
                  </StyledGridRow>
                </Form>
              </FieldSecurityProvider>
            </FormContainer>
          </ModalBody>
        </Modal>
      </>
    );
  },
);

export default DocsModal;
